<template>
  <div class="sidebar open">
    <div class="sidebar-top">
      <div class="logo">
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="60" viewBox="0 0 59 60" fill="none">
          <path
              d="M57.369 25.085L54.8813 19.8603C54.672 19.4309 54.5093 19.0134 54.3581 18.5601L52.5214 13.0492C51.4286 9.78079 48.9292 7.21618 45.744 6.0949L40.3732 4.21021C39.9547 4.079 39.5245 3.88814 39.1293 3.69729L34.0259 1.14461C31.0034 -0.370305 27.4693 -0.370305 24.4468 1.14461L19.3434 3.69729C18.9481 3.90007 18.518 4.079 18.0879 4.23407L12.7171 6.11876C9.53184 7.24003 7.03244 9.80465 5.93969 13.073L4.10292 18.584C3.9518 19.0373 3.77742 19.4547 3.5798 19.8842L1.09203 25.1088C-0.384355 28.2102 -0.384355 31.8365 1.09203 34.9378L3.5798 40.1744C3.77742 40.58 3.9518 41.0213 4.10292 41.4627L5.93969 46.9736C7.03244 50.242 9.53184 52.8066 12.7171 53.9279L18.0879 55.8126C18.518 55.9677 18.9365 56.1466 19.3434 56.3494L24.4468 58.9021C27.4693 60.417 31.0034 60.417 34.0259 58.9021L39.1293 56.3494C39.5245 56.1466 39.9547 55.9677 40.3848 55.8126L45.7556 53.9279C48.9409 52.8066 51.4402 50.242 52.533 46.9736L54.3698 41.4627C54.5209 41.0213 54.6836 40.5919 54.8929 40.1744L57.3807 34.9378C58.8454 31.8126 58.8454 28.1864 57.369 25.085ZM30.7476 19.3474C35.4209 21.8643 38.8735 26.0273 40.8033 31.6575C43.4306 39.3394 39.5362 47.8086 32.131 50.5164C30.8755 50.9816 29.5851 51.2082 28.2715 51.2082C23.4006 51.2082 19.0295 48.0114 17.402 43.252C16.565 40.8066 16.6813 38.1705 17.7624 35.8444C18.8435 33.5064 20.7268 31.7291 23.0751 30.8703C23.9237 30.5601 24.7607 30.3931 25.5744 30.3931C28.4807 30.3931 30.8057 32.4329 31.6427 35.7132C32.3402 38.4209 31.7241 41.1287 30.7825 42.417C30.2129 43.1923 29.6316 43.3474 29.2247 43.3474C27.4345 43.3474 27.202 41.7013 26.9811 40.2579C26.8532 39.3514 26.6905 38.3017 26.2138 37.3235C25.7023 36.2619 24.8769 35.7013 23.8191 35.7013C22.5287 35.7013 21.0755 36.5243 20.1223 37.8126C19.6108 38.4806 18.8203 39.8881 19.2504 41.6178C20.2385 45.5303 23.3192 47.9637 27.3415 47.9637C28.4691 47.9637 29.6083 47.7609 30.7127 47.3673C33.6423 46.2818 36.1416 44.0035 37.5715 41.1048C39.0247 38.1347 39.2688 34.8424 38.2342 31.8365C36.1998 25.8842 32.0961 21.5661 26.7137 19.4547C25.2606 20.1824 23.9353 20.4806 22.7728 20.4806C19.1458 20.4806 16.9951 17.749 16.9719 17.7132C16.9603 17.6893 16.9486 17.6655 16.937 17.6416C16.9138 17.6058 16.9021 17.5701 16.8905 17.5343C16.8673 17.4866 16.8556 17.4388 16.8556 17.3792C16.8556 17.3553 16.8324 17.3434 16.8324 17.3196C16.8324 17.2957 16.844 17.2838 16.844 17.2599C16.844 17.2122 16.8556 17.1764 16.8673 17.1287C16.8789 17.0929 16.8905 17.0452 16.9138 17.0094C16.9254 16.9736 16.9486 16.9378 16.9719 16.914C16.9951 16.8663 17.03 16.8424 17.0649 16.8066C17.0765 16.7947 17.0881 16.7708 17.0881 16.7589C17.1114 16.747 17.1346 16.747 17.1579 16.7351C17.1928 16.7112 17.2276 16.6873 17.2741 16.6754C17.3206 16.6635 17.3555 16.6516 17.402 16.6396C17.4253 16.6396 17.4369 16.6277 17.4718 16.6277L17.8438 16.6158H17.8554C18.0879 16.6158 18.3088 16.6039 18.5296 16.6039L18.89 16.6158C22.3427 16.6396 25.5512 17.2241 28.3412 18.3215C28.2715 17.0333 28.7016 15.4468 29.5851 14.0512C30.7941 12.1188 33.8283 8.85037 40.8963 8.85037H41.5473L41.5589 9.54222C41.5589 9.58993 41.6403 14.9219 35.7464 15.3394C32.0031 15.6019 30.3175 17.1526 30.085 18.1545C30.0268 18.584 30.2245 19.0253 30.7476 19.3474ZM40.1988 10.2102C34.2933 10.4249 31.7939 13.1088 30.7592 14.743C30.5616 15.0532 30.4105 15.3752 30.271 15.6854C31.4102 14.7669 33.2237 14.0392 35.7115 13.8842C39.1874 13.6337 39.9895 11.3792 40.1988 10.2102ZM23.8423 34.3056C25.4233 34.3056 26.7021 35.1526 27.4461 36.7033C28.0041 37.8722 28.1901 39.077 28.3296 40.0551C28.5737 41.6893 28.69 41.9518 29.2363 41.9518C29.3293 41.9518 29.5153 41.8563 29.7246 41.582C30.4686 40.5681 30.8987 38.242 30.3407 36.083C29.6665 33.3991 27.8762 31.8007 25.5861 31.8007C24.9351 31.8007 24.2376 31.9319 23.5517 32.1824C21.5405 32.9339 19.913 34.4369 18.9946 36.4408C18.7621 36.9299 18.5994 37.407 18.4715 37.92C18.6459 37.586 18.8435 37.2639 19.076 36.9538C20.285 35.3434 22.1567 34.3056 23.8423 34.3056ZM24.7026 18.751C23.0169 18.2738 21.1569 18.0114 19.2853 17.9637C20.378 18.7271 22.2613 19.4667 24.7026 18.751Z"
              fill="#213140"/>
        </svg>
      </div>
      <div class="name">
        {{ appName }}
      </div>
    </div>
    <div class="sidebar-body">
      <ul class="menu flex-column">
        <router-link to="/" class="menu-item">
          <span>
            <i class="fas fa-home"></i>
            Главная</span>
        </router-link>
        <a class="menu-item dropdown" @click="openItem">
          <span>
            <i class="fas fa-store"></i>
            Интернет-магазин</span>
          <div class="dropdown-content">
            <router-link to="/list-orders">
              Заказы
            </router-link>
            <router-link to="/list-products">
              Товары
            </router-link>
            <router-link to="/list-category">
              Категории
            </router-link>
          </div>
        </a>
        <a class="menu-item dropdown" @click="openItem">
          <span>
            <i class="fas fa-search-dollar"></i>
            Маркетинг</span>
          <div class="dropdown-content">
            <router-link to="/list-banners">
              Баннеры
            </router-link>
            <router-link to="/promocodes">
              Промокоды
            </router-link>
            <router-link to="/mailing/create">
              Создать рассылку
            </router-link>
          </div>
        </a>
        <a class="menu-item dropdown" @click="openItem">
          <span>
            <i class="fas fa-users"></i>
            Клиенты</span>
          <div class="dropdown-content">
            <router-link to="/list-users">
              Список клиентов
            </router-link>
            <router-link to="/list-question">
              Анкеты
            </router-link>
          </div>
        </a>
        <router-link to="/settings" class="menu-item">
          <span>
            <i class="fas fa-cogs"></i>
            Настройки</span>
        </router-link>
      </ul>
    </div>
    <div class="sidebar-bottom">
      <div class="return-season">
        <i class="fas fa-undo-alt"></i>
        <a :href="appUrl">Домой</a>
      </div>
      <div class="logout" @click="logout">
        <i class="fas fa-sign-out-alt"></i>
        <span>Выйти</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  data: function () {
    return {
      appName: process.env.VUE_APP_NAME,
      appUrl: process.env.VUE_APP_SITE_URL
    }
  },
  methods: {
    openItem: function (e) {
      let el = e.target;
      if (el.parentElement.classList.contains('open')) {
        el.parentElement.classList.remove('open');
      } else {
        el.parentElement.classList.add('open');
      }
    },
    logout: function () {
      this.$store.dispatch("logout");
    },
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  min-height: calc(100vh);
  background: #363740;
  min-width: 255px;
  transition: .3s;
  display: none;

  &.open {
    transition: .3s;
    display: block;
  }

  .sidebar-top {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0 10px 0;
    background: #f5fffa;

    .logo svg {
      width: 50px;
    }

    .name {
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.4px;
      color: #A4A6B3;
      opacity: 0.7;
      margin-left: 13px;
    }
  }

  .sidebar-body {
    margin-top: 20px;
    border-bottom: 1px solid rgba(223, 224, 235, 0.06);

    .menu {
      display: flex;
      list-style: none;
      padding: 0;
      width: 100%;

      .menu-item {
        width: 100%;
        position: relative;
        padding: 18px 0 18px 10px;
        font-size: 16px;
        line-height: 20px;
        color: #A4A6B3;
        text-decoration: none;
        cursor: pointer;

        span {
          transition: all 0.3s;
          padding-left: 17px;

          i {
            color: #A4A6B3;
            font-size: 20px;
            width: 20px;
            margin-right: 5px;
            transition: all 0.3s;
          }
        }

        &.dropdown {
          flex-direction: column;

          span:after {
            font-family: "Font Awesome 5 Free", serif;
            content: "\f0d7";
            display: inline-block;
            vertical-align: middle;
            font-weight: 900;
            padding-left: 5px;
          }
        }

        .dropdown-content {
          display: none;
        }

        &.open .dropdown-content {
          display: flex;
          flex-direction: column;
          padding-left: 30px;
          padding-top: 5px;

          a {
            font-size: 16px;
            line-height: 20px;
            padding-top: 5px;
            color: #A4A6B3;
            text-decoration: none;

            &:hover {
              color: #DDE2FF;
            }
          }
        }

        &:hover {
          color: #DDE2FF;

          i {
            color: #DDE2FF;
          }
        }

        &.router-link-exact-active {
          color: #DDE2FF;

          i {
            color: #DDE2FF;
          }
        }
      }
    }
  }

  .sidebar-bottom {
    margin-top: 20px;

    .return-season {
      padding: 0 0 18px 30px;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #A4A6B3;
      cursor: pointer;

      a {
        padding-left: 23px;

        &:hover {
          color: #DDE2FF;
          text-decoration: none;
        }
      }
    }

    .logout {
      padding: 0 0 18px 30px;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #A4A6B3;
      text-decoration: none;
      cursor: pointer;

      &:hover {
        color: #DDE2FF;
      }

      span {
        padding-left: 23px;
      }
    }
  }
}
</style>
